import * as types from './dashboardActionTypes.js';

export const toggleStatusBoard = (statusBoard) => ({ type: types.TOGGLE_STATUSBOARD, statusBoard: statusBoard });
export const toggleShiftPerformanceBoard = (shiftPerformanceBoard) => ({ type: types.TOGGLE_SHIFTPERFORMANCEBOARD, shiftPerformanceBoard: shiftPerformanceBoard });
export const toggleOEEBoard = (OEEBoard) => ({ type: types.TOGGLE_OEEBOARD, OEEBoard: OEEBoard });
export const toggleProgressionBoard = (progressionBoard) => ({ type: types.TOGGLE_PROGRESSIONBOARD, progressionBoard: progressionBoard });
export const toggleMessagesBoard = (messagesBoard) => ({ type: types.TOGGLE_MESSAGESBOARD, messagesBoard: messagesBoard });
export const setDashboardConfigurationDrawerOpen = (dashboardConfigurationDrawerOpen) => ({ type: types.SET_DASHBOARDCONFIGURATIONDRAWEROPEN, dashboardConfigurationDrawerOpen: dashboardConfigurationDrawerOpen });
export const setTimers = (timers) => ({ type: types.SET_TIMERS, timers: timers });
export const setProgressions = (progressions) => ({ type: types.SET_PROGRESSIONS, progressions: progressions });




